import * as React from 'react';

import { ButtonSpinner } from '../../../Shared/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

interface ImportClassesWarningModalProps {
  alreadyImportedProvider: string;
  close: () => void;
  importClasses: () => void;
  providerTitle: string;
  waiting: boolean;
}

const ImportClassesWarningModal = ({ alreadyImportedProvider, close, importClasses, providerTitle, waiting }: ImportClassesWarningModalProps) => {
  const { modalRef, } = useModalAccessibility(close)

  const renderImportButton = () => {
    if (waiting) {
      return (
        <button aria-label="Loading" className="quill-button contained green medium focus-on-light" type="button">
          <ButtonSpinner />
        </button>
      )
    }

    return (
      <button className="quill-button contained green medium focus-on-light" onClick={importClasses} type="button">Import classes</button>
    )
  }

  return (
    <div className="modal-container import-classes-warning-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="importClassesWarningModalTitle"
        aria-modal={true}
        className="import-classes-warning-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="importClassesWarningModalTitle">Import from {providerTitle}?</h3>
        </div>
        <p>
          You have already imported classes from {alreadyImportedProvider}. Importing classes from {providerTitle} may result in duplicate classes and student accounts. Do you wish to proceed with importing classes from {providerTitle}?
        </p>
        <div className="form-buttons">
          <button className="quill-button outlined green medium focus-on-light" onClick={close} type="button">Cancel</button>
          {renderImportButton()}
        </div>
      </div>
    </div>
  )
}

export default ImportClassesWarningModal
